import { useState } from "react";
import styles from "./Consent.module.scss";

export default function Consent({
  handleConsentCheckboxChange,
  checked,
  communicationConsentRef,
}) {
  const handleChange = () => {
    handleConsentCheckboxChange();
  };

  return (
    <div className={`${styles.consentContainer}`} id="wn-consent-container">
      <input
        type="checkbox"
        id="communication-consent-checkbox"
        className={`${styles.consentCheckbox}`}
        onChange={handleChange}
        checked={checked}
        ref={communicationConsentRef}
      />
      <label
        htmlFor="communication-consent-checkbox"
        className={`${styles.consentLabel}`}
      >
        I would like to receive newsletters and updates to stay informed about
        WhereNext.to&apos;s latest news, blogs, and offerings.
      </label>
    </div>
  );
}
